<mat-expansion-panel *ngIf="ShowFilter()" hideToggle >
  <mat-expansion-panel-header>
    <mat-panel-title> FILTER </mat-panel-title>
  </mat-expansion-panel-header>
  <ng-template matExpansionPanelContent>
    <kendo-filter #filter [filters]="filters" [value]="activeFilter" (valueChange)="onFilterChange($event)"  >
    </kendo-filter>
  </ng-template>
</mat-expansion-panel>

<!--Make a list with the recent broken link clients-->
<div *ngFor="let computer of filteredClients"   >
  <kendo-card  *ngIf="BrokenLink(computer)"  class="clientlist-card"   >
    <kendo-card-header>
      <button kendoButton look="outline" routerLink="/information" (click)="onActivate($event)" [id]="computer.name"  class="k-button large"  [primary]="computer.connected"   [disabled]=true>
        {{ computer.name}}
      </button>
    </kendo-card-header>

    <kendo-card-body>
      <b>{{ computer.clientname }}</b>
      <br/>
      <span class="k-icon k-i-unlink-horizontal k-color-error k-icon-md"></span>
      <small>IP   {{ computer.ip }} </small>
      <br/>
      <small>Seen {{ computer.lle_time | date: 'dd/MM/yy HH:mm:ss' }} </small>
      <br/>
      <small>Version   {{ computer.version }} &nbsp; {{ computer.revision }} </small>
      <br/>

      <br/>

    </kendo-card-body>
  </kendo-card>
</div>


<!--List with the current connected clients-->
<div *ngFor="let computer of filteredClients"   >
  <kendo-card  *ngIf="computer.ip != '0.0.0.0'"  class="clientlist-card"   >
    <kendo-card-header>
      <button kendoButton look="outline" routerLink="/information" (click)="onActivate(computer.name)" [id]="computer.name"  class="k-button large clientid"  [primary]="computer.connected"    [disabled]="!computer.connected">
        {{ computer.name}}
      </button>


      <!--    Has this computer been reset/reboot in last day-->
<!--      <ng-template [ngIf]="computer.uptime >= 0 && computer.uptime < 24*60">-->
<!--        <span class="k-icon k-i-reset k-color-error k-icon-md"></span>-->
<!--      </ng-template>-->


    </kendo-card-header>
    <kendo-card-body>
      <b>{{ computer.clientname }}</b>
      <br/>
      <ng-template [ngIf]="!computer.connected">
        <span class="k-icon k-i-warning k-color-error k-icon-md clientid"></span>
      </ng-template>
      <ng-template [ngIf]="computer.connected">
        <span class="k-icon k-i-link-horizontal k-color-success k-icon-md clientid"></span>
      </ng-template>
      &nbsp;
      <small>IP   {{ computer.ip }} </small>
      <br/>
      <small>Seen {{ computer.lle_time | date: 'dd/MM/yy HH:mm:ss' }} </small>
      <br/>
      <small>Version   {{ computer.version }} &nbsp; {{ computer.revision }} </small>
      <br/>

      <br/>
    </kendo-card-body>
  </kendo-card>
</div>

<div *ngFor="let computer of filteredClients"   >
  <kendo-card  *ngIf="computer.ip == '0.0.0.0'"  class="clientlist-card"   >
    <kendo-card-header>
      <button kendoButton look="outline" routerLink="/information" (click)="onActivate($event)" [id]="computer.name"  class="k-button large"  [primary]="computer.connected"   [disabled]=true>
        {{ computer.name}}
      </button>
    </kendo-card-header>

    <kendo-card-body>
      <b>{{ computer.clientname }}</b>
      <br/>
      <ng-template [ngIf]="!computer.connected">
        <span class="k-icon k-i-warning k-color-error k-icon-md clientid"></span>
      </ng-template>
      <small>IP   {{ computer.ip }} </small>
      <br/>
      <small>Seen {{ computer.lle_time | date: 'dd/MM/yy HH:mm:ss' }} </small>
      <br/>
      <small>Version   {{ computer.version }} &nbsp; {{ computer.revision }} </small>
      <br/>

      <br/>

    </kendo-card-body>
  </kendo-card>
</div>

